import { useState } from "react";
import { Message } from "iconsax-reactjs";
import FeedbackForm from "./FeedbackForm";
import PortalPopup from "./PortalPopup";

const FeedbackManager = () => {
  const [isFeedbackOpen, setFeedbackOpen] = useState(false);

  const openFeedback = () => setFeedbackOpen(true);
  const closeFeedback = () => setFeedbackOpen(false);

  return (
    <>
      {/* 🟨 Feedback Popup */}
      {isFeedbackOpen && (
        <PortalPopup
          overlayColor="rgba(0,0,0,0.25)"
          placement="Centered"
          onOutsideClick={closeFeedback}
        >
          <FeedbackForm onClose={closeFeedback} />
        </PortalPopup>
      )}

      {/* 🟦 Floating Feedback Button — Icon + Text Horizontally */}
      <div
        className="fixed bottom-6 right-6 z-50 flex items-center justify-center gap-2 bg-gradient-to-r from-[#1A1054] via-[#2140B3] to-[#255FF1] text-white rounded-full shadow-lg px-6 py-3 cursor-pointer hover:scale-105 transition-transform duration-300"
        onClick={openFeedback}
        title="Submit Feedback"
      >
        <Message size="22" color="white" />
        <span className="font-semibold text-sm whitespace-nowrap">
          Submit Feedback
        </span>
      </div>
    </>
  );
};

export default FeedbackManager;
